// ─────────────────────────────────────────────────────────────────────────────
// Service-worker registration — the one call that makes the panel installable.
//
// The `new URL('../../sw.js', import.meta.url)` form is not just a URL: it is
// how Parcel DISCOVERS the worker, compiles it for the service-worker
// environment, and emits it at the site root with a stable name. A plain
// string ('/sw.js') is refused by Parcel. Kept in its own module (as in the
// doctor app) so everything testable about PWA behaviour lives in pwa.js and
// swPolicy.js, and App.jsx is the only caller.
//
// The guards are the feature:
//   • production bundles only — a worker over the dev server poisons every
//     reload;
//   • automated browsers (Playwright sets navigator.webdriver) never
//     register, so e2e runs cannot leak cache state between tests;
//   • registration failure is silent — the panel ran without a worker for
//     its whole life and keeps working exactly the same without one.
// ─────────────────────────────────────────────────────────────────────────────

export function registerServiceWorker() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;
  if (navigator.webdriver) return;
  window.addEventListener('load', () => {
    // type: 'module' is what lets sw.js use ESM imports. Parcel resolves them
    // at build time and, since the emitted worker has none left, rewrites this
    // registration to a plain classic one — the option exists for the
    // bundler, not the browser.
    navigator.serviceWorker
      .register(new URL('../../sw.js', import.meta.url), { type: 'module', scope: '/' })
      .catch(() => {
        /* no worker → no offline shell, nothing else changes */
      });
  });
}
